import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle} from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Select,
  Button,
  Space,
  message,
  InputNumber,
  Input
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import dayjs from "dayjs";
import commonFn from "@/utils/commonFn";

const VendorTypeModal = forwardRef(({ submitInitFn }, ref) => {
    const [form] = Form.useForm();
    const [type, setType] = useState('add');
    const [oldState, setOldState] = useState({});
    const [modalName, setModalName] = useState('Payment Request');
    const [modalFlag, setModalFlag] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [targetFieldsList, setTargetFieldsList] = useState([]);
    const [validationTypeKey, setValidationTypeKey] = useState(0);
    
    useImperativeHandle(ref, () => ({
      openModal: ({type, modalName, oldState}) => {
        setType(type)
        setModalName(modalName)
        setOldState(oldState)
        setModalFlag(true)
      }
    }));

    const afterOpenChangeFn = (flag) => {
      if(flag){
        if(type !== 'add'){
          getDetailFn()
        } else {
        }
      }else{
        form.resetFields();
        setBtnLoading(false)
        setBtnDisabled(false)
      }
    }

    const getDetailFn = async() => {
        setBtnDisabled(true)
        getTargetFieldsList()
        const { id } = oldState
        const response = await http.get(api.vendorTypeById, { params: { id } });
        form.setFieldsValue({
          ...response.data,
        });
        setBtnDisabled(false)
    }

    const submitAddOrEditFn = async(type) => {
      const flag = type === 'add'
      setBtnLoading(true)
      const response = await http.post(flag ? api.vendorTypeAdd : api.vendorTypeUpdate, {
        settingsDictItem: {
          id: oldState?.id,
          ...form.getFieldValue(),
        },
        entityFieldValidationRule: {
          ...form.getFieldValue(),
        }
      });
      if (response.code === "1") {
        message.success(`${flag ? 'New' : 'Edit'} successfully`);
        setModalFlag(false)
        submitInitFn();
      } else {
        commonFn.modalFailedFn(response)
      }
      setBtnLoading(false)
    }

    const submitFn = async() => {
      form.validateFields().then(value => {
        if(type === 'add' || type === 'edit'){
          submitAddOrEditFn(type)
        }
      }).catch(err =>{
        console.log(err,'===err');
      })
    }

    const getTargetFieldsList = async () => {
      const response = await http.get(api.fieldRuleField, {params: {tableName: 'new_vendor'}});
      setTargetFieldsList(response?.data || []);
    };  

    useEffect(() => {
      getTargetFieldsList();
    }, []);

  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "#3c8dbc" }}>
          <HomeOutlined style={{ marginRight: "8px" }} />
          {modalName}
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      maskClosable={false}
      afterOpenChange={afterOpenChangeFn}
      width="30%"
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{span: 8}}
        wrapperCol={{span: 16}}
        labelWrap={true}
        labelAlign="right"
        initialValues={{
          validationType: 'Required'
        }}
        validateMessages={{
          required: "${label} is required!",
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>

            <Form.Item
              name="code"
              label="Type Code"
              rules={[{ required: true, message: 'Type Code is required!' }]}
            >
              <Input
                placeholder="Please input Type Code"
              />
            </Form.Item>

            <Form.Item
              name="name"
              label="Type Name"
              rules={[{ required: true, message: 'Type Name is required!' }]}
            >
              <Input
                placeholder="Please input Type Name"
              />
            </Form.Item>

            <Form.Item
              name="status"
              label="Active"
              rules={[{ required: true, message: 'Active is required!' }]}
            >
              <Select
                placeholder="Select a type"
                options={[
                { value: 1, label: "Active" },
                { value: 0, label: "Inactive" },
              ]}
              />
            </Form.Item>

            <Form.Item
              name="order"
              label="Order"
            >
              <Input
                placeholder="Please input Order"
              />
            </Form.Item>

            <Form.Item
              name="desc"
              label="Description"
            >
              <Input
                placeholder="Please input Description"
              />
            </Form.Item>

            {/* <Form.Item
              name="conditionOperator"
              label="Condition Operator"
            >
              <Input
                placeholder="Please input Condition Operator"
              />
            </Form.Item> */}

            <Form.Item
              name="targetFields"
              label="Target Fields"
              // rules={[{ required: true, message: 'Target Fields is required!' }]}
            >
              <Select
                showSearch
                allowClear
                mode="multiple"
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  value: 'fieldName',
                  label: 'label',
                }}
                options={targetFieldsList}
              />
            </Form.Item>
            
            <Form.Item
              name="validationType"
              label="Validation Type"
            >
              <Select
                disabled
                placeholder="Select a type"
                onChange={(e) => setValidationTypeKey(+new Date())}
                options={[
                    {label: 'Required', value: 'Required'},
                    // {label: 'Regex', value: 'Regex'},
                    // {label: 'Range', value: 'Range'},
                ]}
              />
            </Form.Item>

            {['Regex', 'Range'].includes(form.getFieldValue().validationType) && (
              <Form.Item
                name="validationConfig"
                label="Validation Config"
                // rules={[{ required: true, message: 'Validation Config is required!' }]}
              >
                <Input
                  placeholder="Please input Validation Config"
                />
              </Form.Item>
            ) || null}

            <Form.Item
              name="remark"
              label="Remark"
            >
              <Input.TextArea
                placeholder="Please input Remark"
                autoSize={{ minRows: 3, maxRows: 10 }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div style={{textAlign:'center'}}>
        <Space align="center">
          {/* <Button key="back" onClick={testFn}>
            TEST
          </Button> */}
          <Button key="back" onClick={() => setModalFlag(false)}>
            Cancel
          </Button>
          {
            type !== 'view' && (
              <Button type="primary" onClick={() => submitFn()} loading={btnLoading} disabled={btnDisabled}>
                Submit
              </Button>
            ) || null
          }
        </Space>
      </div>
    </Modal>
  );
});

export default VendorTypeModal;